import angular from 'angular';

import assignmentTypesFactory from './assignment-types-factory';

const assignmentShared = angular.module('assignmentShared', []);

assignmentShared.factory('assignmentTypesFactory', assignmentTypesFactory);

export default assignmentShared.name;
